import { render } from "./NasabahAdd.vue?vue&type=template&id=1df1d5e4&scoped=true"
import script from "./NasabahAdd.vue?vue&type=script&lang=js"
export * from "./NasabahAdd.vue?vue&type=script&lang=js"

import "./NasabahAdd.vue?vue&type=style&index=0&id=1df1d5e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.20_vue@3.5.20_webpack@5.101.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1df1d5e4"]])

export default __exports__